// @flow

import { cause } from 'verror';

export const findRootCause = (error: Error) => {
  let result = error;
  while (cause(result)) {
    result = cause(result);
  }

  return result;
};
